import React from 'react';
import { Modal, Form, Input, InputNumber, Button, Space, Alert, Switch, Grid } from 'antd';

const { useBreakpoint } = Grid;

const FolioSerieModal = ({ 
  visible, 
  onCancel, 
  onFinish, 
  form, 
  selectedFolioSerie, 
  selectedCompany,
  loading 
}) => {
  const screens = useBreakpoint();

  return (
    <Modal
      title={selectedFolioSerie ? 'Editar Serie de Folio' : 'Nueva Serie de Folio'}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={screens.xs ? '100%' : 400}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
      >
        <Alert
          message="Información"
          description={`Esta serie se asociará a la empresa: ${selectedCompany?.tax_name} - ${selectedCompany?.tax_id}`}
          type="info"
          showIcon
          style={{ marginBottom: '16px' }}
        />

        <Form.Item
          name="serie"
          label="Serie"
          rules={[{ required: true, message: 'La serie es requerida' }]}
        >
          <Input placeholder="Ej: A, B, C, etc." />
        </Form.Item>

        <Form.Item
          name="folio"
          label="Folio Inicial"
          rules={[
            { required: true, message: 'El folio inicial es requerido' },
            { type: 'number', min: 1, message: 'El folio debe ser mayor a 0' }
          ]}
        >
          <InputNumber 
            style={{ width: '100%' }}
            placeholder="1"
            min={1}
          />
        </Form.Item>

        <Form.Item
          name="enabled"
          label="Estado"
          valuePropName="checked"
          initialValue={true}
        >
          <Switch 
            checkedChildren="Activa" 
            unCheckedChildren="Inactiva" 
          />
        </Form.Item>

        <Form.Item style={{ textAlign: 'right', marginBottom: 0 }}>
          <Space>
            <Button onClick={onCancel}>
              Cancelar
            </Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              {selectedFolioSerie ? 'Actualizar' : 'Crear'} Serie
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default FolioSerieModal;